const isDevelopment = process.env.NODE_ENV === "development";
const isTesting = process.env.NODE_ENV === "testing";
const isProduction = process.env.NODE_ENV === "production";
const baseUrl = process.env.APP_BASE_URL;
const testBaseUrl = process.env.APP_BASE_URL_TEST;

export const Config = {
  isDevelopment,
  isTesting,
  isProduction,
  baseUrl,
  testBaseUrl,
  apiUrl: process.env.API_URL,
  wsUrl: process.env.WS_URL,

  Auth0: {
    domain: process.env.AUTH0_DOMAIN,
    clientId: process.env.AUTH0_CLIENT_ID,
    audience: process.env.AUTH0_AUDIENCE,
    audienceTest: process.env.AUTH0_AUDIENCE_TEST,
    clientIdTest: process.env.AUTH0_CLIENT_ID_TEST,
    domainTest: process.env.AUTH0_DOMAIN_TEST,
    loginWithPopup: process.env.AUTH0_LOGIN_WITH_POPUP === "true",
    defaultReturnTo: "/",
  },
  Sentry: {
    Environment: process.env.SENTRY_ENVIRONMENT ?? "development",
    dsn: process.env.UI_SENTRY_DSN,
    tracesSampleRate: isDevelopment ? 1.0 : 0.4,
    release: process.env.BUILD_VERSION,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
    ],
  },
  Userflow: {
    userflowToken: process.env.USERFLOW_TOKEN,
  },
  Links: {
    SupportArticles: {
      AD_Groups_Help: process.env.ADGROUP_SUPPORT_ARTICLE_URL,
    },
  },
};
